/**
 * KI-Agent Sichtbarkeits-Logik
 * 
 * REGEL: Der KI-Agent ist NUR für den Admin (Andreas Koop) sichtbar.
 * Für alle anderen Mitarbeiter wird er als "System" angezeigt oder komplett ausgeblendet.
 * 
 * Mitarbeiter-ID des KI-Agenten: 00000000-0000-0000-0000-000000000099
 */

export const KI_AGENT_ID = '00000000-0000-0000-0000-000000000099';

/**
 * Prüft ob eine Mitarbeiter-ID die des KI-Agenten ist
 */
export function isKiAgent(mitarbeiterId: string | null | undefined): boolean {
  return mitarbeiterId === KI_AGENT_ID;
}

/**
 * Gibt den Anzeigenamen zurück:
 * - Admin sieht "KI Agent"
 * - Alle anderen sehen "System"
 */
export function getKiAgentDisplayName(isAdmin: boolean): string {
  return isAdmin ? 'KI Agent' : 'System';
}

/**
 * Gibt die Anzeige-Rolle zurück:
 * - Admin sieht "KI-Agent"
 * - Alle anderen sehen "Automatisierung"
 */
export function getKiAgentDisplayRole(isAdmin: boolean): string {
  return isAdmin ? 'KI-Agent' : 'Automatisierung';
}

/**
 * Filtert den KI-Agent aus einer Mitarbeiter-Liste (für Nicht-Admins)
 */
export function filterKiAgent<T extends { id: string; rolle?: string }>(
  mitarbeiter: T[],
  isAdmin: boolean
): T[] {
  if (isAdmin) return mitarbeiter;
  return mitarbeiter.filter(m => m.id !== KI_AGENT_ID && m.rolle !== 'ki_agent');
}

/**
 * Prüft ob KI-bezogene UI-Elemente angezeigt werden sollen
 */
export function showKiElements(isAdmin: boolean): boolean {
  return isAdmin;
}
